import { render } from "./tablecontent.vue?vue&type=template&id=2eb28ad6"
import script from "./tablecontent.vue?vue&type=script&lang=js"
export * from "./tablecontent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__